<app-popup
    [title]="'AddContact' | localize"
    [isButtonShown]="false">
    <app-client-add-popup-form
        (onSubmit)="onSubmit($event)" />
</app-popup>
